<template>
  <div>
    <div class="invoiceList">
      <v-layout row wrap>
        <v-flex xs12>
          <v-toolbar class="primary white--text" style="margin-top: 10px">
            <v-flex xs12 md1 sm1>
              <h3 class="title font-weight-light">Receipt Register</h3>
            </v-flex>
            <template>
              <v-flex xs12 md2 sm2>
                <v-select
                  class="select-firm"
                  dense
                  :items="firmsByBrand"
                  label="Select Firm"
                  v-model="selectedFirm"
                  clearable
                ></v-select>
              </v-flex>
              <v-spacer />
              <v-flex xs12 sm2 md2>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerFrom"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  class="white-datepicker"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateFrom"
                    label="From Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="dateFrom"
                    @input="datepickerFrom = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-spacer />
              <v-flex xs12 sm2 md2>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerTo"
                  :nudge-right="40"
                  lazy
                  class="white-datepicker"
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateTo"
                    label="To Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="dateTo"
                    @input="datepickerTo = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-spacer />
              <v-flex xs12 md1 sm1>
                <v-btn 
                  icon dark
                  @click="print()"
                  style="float: left"
                >
                <v-icon class="primary white--text">
                  picture_as_pdf
                </v-icon>                  
                </v-btn>
                <v-spacer/>

                <router-link to="/Dashboard">
                  <v-btn icon dark style="float: right">
                    <v-icon>close</v-icon>
                  </v-btn>
                </router-link>
              </v-flex>
            </template>
          </v-toolbar>
        </v-flex>
      </v-layout>
      <!-- <v-data-table :items="invoicesByBrand" class="elevation" :headers="headers"> -->
      <v-data-table
        :items="normalData"
        class="elevation transaction-table"
        :pagination.sync="pagination"
        :headers="headers"
      >
        <template slot="items" slot-scope="props">
          <tr>
            <td>
              <b class="font-weight-bold">{{ props.item.firmName }}</b>
            </td>
            <td>
              <b class="font-weight-bold">{{
                new Date(props.item.date).toLocaleDateString("en-IN")
              }}</b>
            </td>
            <td>
              <b class="font-weight-bold" v-if="props.item.buyerId"
                > {{ props.item.buyerName }}
              </b>
            </td>
            <td>
              <b class="green--text font-weight-bold">
                {{ props.item.receiptNumber || '' }}
              </b>
            </td>
            <td>
              <b class="green--text font-weight-bold">
                {{ props.item.amount || 0 | amount }}
              </b>
            </td>
            <td>
              <b class="font-weight-bold">{{ props.item.paymentType }}</b>
            </td>
          </tr>
        </template>
        <template slot="no-data">No rows to Show</template>
      </v-data-table>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
import { convertToPDFReport } from "../../utils/pdf-reports/receipt-register-report";

export default {
  data: () => ({
    headers: [
      { text: "Firm", value: "date", sortable: true },
      { text: "Date", value: "date", sortable: true },
      { text: "Customer Name", value: "expense", sortable: true },
      { text: "Receipt Number", value: "receiptNumber", sortable: true },
      { text: "Amount", value: "category", sortable: true },
      { text: "Payment type", value: "totalAmount", sortable: false },
    ],
    pagination: {
      rowsPerPage: 10, // -1 for All",
    },
    businessType: null,
    isStatementView: false,
    statmentData: [],
    normalData: [],
    dateFrom: null,
    dateTo: null,
    datepickerFrom: false,
    selectedFirm: null,
    selectedBranch: null,
    datepickerTo: false,
    dialog11: false,
    selectedInvoice: null,
  }),
  created() {
    this.$bindAsArray(
      "firms",
      this.$root.$firebaseRefs.firm
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsObject(
      "sellers",
      this.$root.$firebaseRefs.seller
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsObject(
      "buyers",
      this.$root.$firebaseRefs.buyer
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "customerPayments",
      this.$root.$firebaseRefs.customerPayments
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    if (this.$route.params.month && this.$route.params.date) {
      let date = parseInt(this.$route.params.date);
      let dateF = 1;
      let dateT = 0;
      if (date > 0) {
        dateF = date;
        dateT = date;
      }
      let selectedMonth = Number.parseInt(this.$route.params.month);
      let dateFrom = new Date(this.finYear.start);
      let dateTo = new Date(this.finYear.end);
      let fullYear = dateFrom.getFullYear();
      if (selectedMonth < 3) {
        fullYear = dateTo.getFullYear();
      }
      this.dateFrom = this.formatDate(
        new Date(fullYear, selectedMonth, dateF).getTime()
      );
      this.dateTo = this.formatDate(
        new Date(
          fullYear,
          dateT == 0 ? selectedMonth + 1 : selectedMonth,
          dateT
        ).getTime()
      );
    } else if (this.finYear) {
      this.dateFrom = this.formatDate(this.finYear.start);
      this.dateTo = this.formatDate(this.finYear.end);
    }
    this.invoicesByBrandNormal();
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand", "finYear"]),
    firmsByBrand() {
      return this.firms
        .filter((item) => item["brand"] === this.selectedBrand)
        .map((item) => {
          if (item.defaultFirm) {
            this.selectedFirm = item[".key"];
          }
          return {
            text: item["name"],
            value: item[".key"],
          };
        });
    },
  },
  watch: {
    selectedFirm: {
      handler(newVal, oldVal) {
        this.invoicesByBrandNormal();
      },
      deep: true,
    },
    selectedBranch: {
      handler(newVal, oldVal) {
        console.log(newVal);
        this.invoicesByBrandNormal();
      },
      deep: true,
    },
    dateTo: {
      handler(newVal, oldVal) {
        this.invoicesByBrandNormal();
      },
    },
    dateFrom: {
      handler(newVal, oldVal) {
        this.invoicesByBrandNormal();
      },
    },
  },
  methods: {
    print(){
      let doc = convertToPDFReport({
        invoiceData:this.normalData,
        firm:this.selectedFirm ? this.getFirmName(this.selectedFirm) : null,
        fromDate : this.dateFrom ? new Date(this.dateFrom).toLocaleDateString('en-GB') : null,
        toDate :  this.dateTo ? new Date(this.dateTo).toLocaleDateString('en-GB') : null,
      });
      pdfMake.createPdf(doc).download('Receipt Register_'+ new Date(this.dateFrom).toLocaleDateString('en-GB') + 'to' + new Date(this.dateTo).toLocaleDateString('en-GB'));
    },
    invoicesByBrandNormal() {
      let toDate = this.dateTo
        ? new Date(this.dateTo).setUTCHours(23, 59, 59, 999)
        : null;
      let fromDate = this.dateFrom
        ? new Date(this.dateFrom).setUTCHours(0, 0, 0, 0)
        : null;

      let invoiceHistory = this.customerPayments.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          (this.selectedFirm ? item["firm"] === this.selectedFirm : true) &&
          (this.isBuyer ? item.isBuyer == false : item.isBuyer == true) &&
          (fromDate ? item.date >= fromDate : true) &&
          (toDate ? item.date <= toDate : true)
      );
      invoiceHistory.map((item,index)=>{
        invoiceHistory[index]['firmName'] = this.getFirmName(item.firm);
        invoiceHistory[index]['buyerName'] = this.buyerById(item.buyerId)["name"]
      })
      this.normalData = invoiceHistory;
    },
    buyerById(id) {
      if (this.buyers[id]) {
        return this.buyers[id];
      } else if (this.sellers[id]) {
        return this.sellers[id];
      }
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    getFirmName(id) {
      let firm = this.firms.filter((item) => item[".key"] == id)[0];
      if (firm) {
        return firm["name"];
      }
    },
  },
};
</script>

<style>
.flexColumn {
  flex-direction: column;
  align-items: flex-start;
}
.theme--light .white-switch {
  margin-top: 25px;
}

.theme--light .white-switch .v-label {
  color: white;
}

.white-datepicker .v-icon,
.white-datepicker .v-label,
.white-datepicker input {
  color: white !important;
}

.white-datepicker .v-input__slot:before {
  border-color: white !important;
}
.theme--light div.select-firm .v-icon {
  color: white;
}
.theme--light div.select-firm .v-label {
  color: white;
}
.theme--light div.select-firm .v-input__slot:before {
  border-color: white !important;
}
div.select-firm .v-select__selection--comma {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/ReceiptRegister/receiptList.vue